import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";
import styles from "./SnapshotMemberItem.module.css";

/**
 * A view component that displays information about a member in the snapshot members list.
 */

export function SnapshotMemberItem({ snapshotMemberInfo }) {
  // set up default state
  const [_snapshotMemberInfo, setEventMemberInfo] = useState({
    iboNum: "N/A",
    name: "N/A",
    pinLevel: null,
    platinum: "N/A",
    emerald: "N/A",
    diamond: "N/A",
  });

  useMemo(() => {
    // null checking
    if (snapshotMemberInfo && snapshotMemberInfo !== null)
      setEventMemberInfo((prev) => ({
        iboNum:
          snapshotMemberInfo.iboNum && snapshotMemberInfo.iboNum !== null
            ? snapshotMemberInfo.iboNum
            : prev.iboNum,
        name:
          snapshotMemberInfo.name && snapshotMemberInfo.name !== null
            ? snapshotMemberInfo.name
            : prev.name,
        pinLevel:
          snapshotMemberInfo.pinLevel && snapshotMemberInfo.pinLevel !== null
            ? snapshotMemberInfo.pinLevel
            : prev.pinLevel,
        platinum:
          snapshotMemberInfo.platinum && snapshotMemberInfo.platinum !== null
            ? snapshotMemberInfo.platinum
            : prev.platinum,
        emerald:
          snapshotMemberInfo.emerald && snapshotMemberInfo.emerald !== null
            ? snapshotMemberInfo.emerald
            : prev.emerald,
        diamond:
          snapshotMemberInfo.diamond && snapshotMemberInfo.diamond !== null
            ? snapshotMemberInfo.diamond
            : prev.diamond,
      }));
  }, [snapshotMemberInfo]);

  return (
    <>
      <div className={styles.container}>
        <div>{_snapshotMemberInfo.iboNum}</div>
        <div>{_snapshotMemberInfo.name}</div>
        <div>
          {_snapshotMemberInfo.pinLevel === null
            ? "N/A"
            : _snapshotMemberInfo.pinLevel === 1
            ? "1 - IBO"
            : _snapshotMemberInfo.pinLevel === 2
            ? "2 - Platinum"
            : _snapshotMemberInfo.pinLevel === 3
            ? "3 - Emerald"
            : _snapshotMemberInfo.pinLevel === 4
            ? "4 - Diamond"
            : _snapshotMemberInfo.pinLevel}
        </div>
        <div>{_snapshotMemberInfo.platinum}</div>
        <div>{_snapshotMemberInfo.emerald}</div>
        <div>{_snapshotMemberInfo.diamond}</div>
      </div>
    </>
  );
}

SnapshotMemberItem.propTypes = {
  // Object with the members info
  snapshotMemberInfo: PropTypes.shape({
    iboNum: PropTypes.string,
    name: PropTypes.string,
    pinLevel: PropTypes.number,
    platinum: PropTypes.string,
    emerald: PropTypes.string,
    diamond: PropTypes.string,
  }),
};
